import { render, staticRenderFns } from "./ValidationError.vue?vue&type=template&id=5ad5c124&"
import script from "./ValidationError.vue?vue&type=script&lang=js&"
export * from "./ValidationError.vue?vue&type=script&lang=js&"
import style0 from "./ValidationError.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports